import { Directive, ElementRef, HostListener } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

// Datas impossíveis (ex.: 30/02) ou incompletas deixam o input nativo em estado
// "badInput": o valor chega vazio ao model e nada era sinalizado ao usuário.
// Aqui isso vira um erro de formulário (dataInvalida) que a tela pode exibir.
@Directive({
  selector: 'input[type=date][ngModel], input[type=datetime-local][ngModel],' +
            'input[type=date][formControl], input[type=datetime-local][formControl],' +
            'input[type=date][formControlName], input[type=datetime-local][formControlName]',
  standalone: false,
  providers: [{
    provide: NG_VALIDATORS,
    useExisting: DateValidityDirective,
    multi: true
  }]
})
export class DateValidityDirective implements Validator {

  private control: AbstractControl | null = null;

  constructor(private el: ElementRef<HTMLInputElement>) {}

  validate(control: AbstractControl): ValidationErrors | null {
    this.control = control;
    return this.el.nativeElement?.validity?.badInput ? { dataInvalida: true } : null;
  }

  // validity.badInput muda sem alterar o valor do controle (o input devolve
  // string vazia), então a revalidação precisa ser disparada na mão.
  @HostListener('input')
  @HostListener('blur')
  revalidate(): void {
    this.control?.updateValueAndValidity({ emitEvent: false });
  }
}
